export default "__VITE_ASSET__C3rzGUvl__"